/**
 * Trowel Media Gallery — syncs thumbnails with slideshow-component.
 *
 * Attaches to any <media-gallery> with data-presentation="trowel-gallery".
 * The slideshow-component handles swipe, drag, and arrow navigation.
 * This script wires thumbnail clicks/keyboard to slideshow.select()
 * and keeps thumbnail active state in sync via the slideshow:select event.
 */
(function () {
  // This script now loads on every page that can render the quick-add modal
  // (via snippets/quick-add-modal.liquid) as well as on the product page (via
  // snippets/trowel-product-media-gallery.liquid). Guard so the single global
  // MutationObserver below is only ever wired once, no matter how many times the
  // file is included on a page.
  if (window.__trowelMediaGalleryInit) return;
  window.__trowelMediaGalleryInit = true;

  function init(gallery) {
    // Idempotent per gallery: the observer can see the same node more than once
    // (e.g. the quick-add modal re-morphing its content), and we must not stack
    // duplicate click/keydown listeners.
    if (gallery.dataset.trowelGalleryReady) return;
    const thumbs = gallery.querySelector('.trowel-media-gallery__thumbs');
    const slideshow = gallery.querySelector('slideshow-component');
    if (!thumbs) return;
    gallery.dataset.trowelGalleryReady = '1';

    // Jump instantly on direct selection. The animated path in slideshow.js
    // briefly sets #disabled=true while it reorders the DOM, which would drop
    // rapid follow-up clicks and leave the thumbnails out of sync with the stage.
    // The `slideshow:select` listener below is the single source of truth for
    // thumbnail active state, so it also reflects drags/swipes/arrows correctly.
    thumbs.addEventListener('click', function (e) {
      var btn = e.target.closest('.trowel-media-gallery__thumb');
      if (!btn) return;
      var index = parseInt(btn.dataset.mediaIndex, 10);
      if (slideshow && slideshow.select) {
        slideshow.select(index, undefined, { animate: false });
      }
    });

    thumbs.addEventListener('keydown', function (e) {
      var current = gallery.querySelector('.trowel-media-gallery__thumb--active');
      if (!current) return;
      var next = null;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        next = current.nextElementSibling;
      } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        next = current.previousElementSibling;
      }
      if (next && next.classList.contains('trowel-media-gallery__thumb')) {
        e.preventDefault();
        next.focus();
        var index = parseInt(next.dataset.mediaIndex, 10);
        if (slideshow && slideshow.select) {
          slideshow.select(index, undefined, { animate: false });
        }
      }
    });

    if (slideshow) {
      slideshow.addEventListener('slideshow:select', function (e) {
        syncThumbnails(gallery, e.detail.index);
      });
    }
  }

  function syncThumbnails(gallery, index) {
    var thumbs = gallery.querySelectorAll('.trowel-media-gallery__thumb');
    var active = null;
    for (var i = 0; i < thumbs.length; i++) {
      var isActive = i === index;
      thumbs[i].classList.toggle('trowel-media-gallery__thumb--active', isActive);
      thumbs[i].setAttribute('aria-selected', String(isActive));
      thumbs[i].setAttribute('tabindex', isActive ? '0' : '-1');
      if (isActive) active = thumbs[i];
    }
    scrollActiveThumbIntoView(gallery, active);
  }

  // Keep the active thumbnail visible inside the horizontally-scrolling strip
  // (mobile). As the user swipes/arrows through the media, the strip follows the
  // selection so the current thumbnail is never left off-screen. Scrolls only the
  // thumb container's own horizontal scroll — never the page. A no-op on desktop
  // where the thumbnails wrap in a grid rather than scrolling.
  function scrollActiveThumbIntoView(gallery, active) {
    if (!active) return;
    var thumbs = gallery.querySelector('.trowel-media-gallery__thumbs');
    if (!thumbs) return;
    var containerRect = thumbs.getBoundingClientRect();
    var thumbRect = active.getBoundingClientRect();
    // Keep the active thumb off the very edge so the neighbouring thumb peeks in,
    // making the progression through the strip readable.
    var gutter = 16;
    var delta = 0;
    if (thumbRect.left < containerRect.left + gutter) {
      delta = thumbRect.left - containerRect.left - gutter;
    } else if (thumbRect.right > containerRect.right - gutter) {
      delta = thumbRect.right - containerRect.right + gutter;
    }
    if (delta !== 0) {
      thumbs.scrollBy({ left: delta, behavior: 'smooth' });
    }
  }

  document.querySelectorAll('media-gallery[data-presentation="trowel-gallery"]').forEach(init);

  // Galleries appear later in two places only: markup morphed into the quick-add
  // modal, and (in the theme editor) whole sections re-rendered on setting
  // changes. Observe just those roots — a body-wide subtree observer runs on
  // every DOM mutation on every page for the life of the session.
  var observer = new MutationObserver(function (mutations) {
    for (var mi = 0; mi < mutations.length; mi++) {
      var added = mutations[mi].addedNodes;
      for (var ni = 0; ni < added.length; ni++) {
        var node = added[ni];
        if (node.nodeType === 1) {
          var gallery = node.matches && node.matches('media-gallery[data-presentation="trowel-gallery"]')
            ? node
            : node.querySelector && node.querySelector('media-gallery[data-presentation="trowel-gallery"]');
          if (gallery) init(gallery);
        }
      }
    }
  });

  var quickAddDialog = document.getElementById('quick-add-dialog');
  if (quickAddDialog) {
    observer.observe(quickAddDialog, { childList: true, subtree: true });
  }
  if (window.Shopify && window.Shopify.designMode) {
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
